import * as Sentry from '@sentry/vue'

type SentryMetricAttributes = Record<string, string | number | boolean>

const SENTRY_ATTRIBUTE_ALLOWLIST = new Set([
  'action',
  'api_area',
  'description',
  'fatal',
  'feature',
  'frontend_route',
  'has_redirect',
  'method',
  'metric',
  'navigation_type',
  'reason',
  'route_name',
  'source',
  'stage',
  'status',
  'success',
  'workflow_entity',
])

const isSentryEnabled = () => import.meta.env.MODE.toString().toLowerCase().trim() === 'production'

const sanitizeMetricAttributes = (attributes: Record<string, unknown> = {}): SentryMetricAttributes =>
  Object.entries(attributes).reduce<SentryMetricAttributes>((safeAttributes, [key, value]) => {
    if (!SENTRY_ATTRIBUTE_ALLOWLIST.has(key)) return safeAttributes
    if (typeof value === 'number' && Number.isFinite(value)) {
      return { ...safeAttributes, [key]: value }
    }
    if (typeof value === 'string' || typeof value === 'boolean') {
      return { ...safeAttributes, [key]: value }
    }
    return safeAttributes
  }, {})

export const trackSentryTelemetryEvent = (event: string, properties: Record<string, unknown> = {}) => {
  if (!isSentryEnabled()) return

  Sentry.metrics.count('kaizen.frontend.telemetry.event', 1, {
    attributes: {
      event,
      ...sanitizeMetricAttributes(properties),
    },
  })
}

export const trackSentryPerformanceMetric = (metric: string, value: number, properties: Record<string, unknown> = {}) => {
  if (!isSentryEnabled() || !Number.isFinite(value)) return

  Sentry.metrics.distribution('kaizen.frontend.performance.duration', value, {
    unit: 'millisecond',
    attributes: {
      metric,
      ...sanitizeMetricAttributes(properties),
    },
  })
}
